class gtmEvents {
    constructor() {
        this.delegateBody = new Delegate(document.body);
        this.bindEvents();
    }

    bindEvents(){
        this.delegateBody.on("filters:sort:open", this.filterSortOpen.bind(this));
        this.delegateBody.on("filters:sort:close", this.filterSortClose.bind(this));

        document.addEventListener("sort:changed", this.sendSortByData.bind(this));
        document.addEventListener("filter:changed", this.sendFiltersData.bind(this));
        document.addEventListener("filter:sort:removed", this.filterSortClear.bind(this));
       
    }

    filterSortOpen() {
        //console.log('Filter sort open');
        dataLayer.push({
            event: "filter_sort_dropdown-open"
        });
    }

    filterSortClose() {
        //console.log('Filter sort close');
        dataLayer.push({
            event: "filter_sort_dropdown-close"
        });
    }

    filterSortClear(){
        //console.log('Filter sort clear');
        dataLayer.push({
            event: "filter_sort-removed",
            filter_by: [],
        });
    }

    sendSortByData(){
        const sortBy = document.querySelector('input[name="sort_by"]:checked');    
        if (!sortBy) return;

        const sortByValue = sortBy.value;
        dataLayer.push({
            event: "sort_applied",
            sort_by: sortByValue,
        });

        //console.log(dataLayer);
    }

    sendFiltersData() {
        function arraysEqual(arr1, arr2) {
            if (!arr1 || !arr2) return arr1 === arr2;
            return (
            Array.isArray(arr1) &&
            Array.isArray(arr2) &&
            arr1.length === arr2.length &&
            arr1.every((val, index) => val === arr2[index])
            );
        }

        const filtersList = [];
        const filterCheckboxes = document.querySelectorAll('.inputFilterCheckbox');

        filterCheckboxes.forEach((checkbox) => {
            if (checkbox.checked) {
            const filterName = checkbox.dataset.filterName || checkbox.name; // fallback ako nema dataset
            filtersList.push(`${filterName}:${checkbox.value}`);
            }
        });

        if (!filtersList.length) return;

        let oldFiltersList;
        try {
            oldFiltersList = JSON.parse(sessionStorage.getItem("CollectionsFiltersList")) || [];
        } catch (e) {
            oldFiltersList = [];
        }


        if (arraysEqual(filtersList, oldFiltersList)) return;

        sessionStorage.setItem("CollectionsFiltersList", JSON.stringify(filtersList));

        dataLayer.push({
            event: "filter_applied",
            filter_by: filtersList,
        });

        //console.log('Pushed filters:', filtersList);
    }

}

new gtmEvents();